/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/** *************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es/array';
import 'core-js/es/date';
import 'core-js/es/function';
import 'core-js/es/map';
import 'core-js/es/math';
import 'core-js/es/number';
import 'core-js/es/object';
import 'core-js/es/parse-float';
import 'core-js/es/parse-int';
import 'core-js/es/regexp';
import 'core-js/es/set';
import 'core-js/es/string';
import 'core-js/es/symbol';
import 'core-js/es/weak-map';

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'core-js/es/reflect';

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 **/
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.

import * as process from 'process';
window['process'] = process;

// fixes monaco error message
Promise.all = function (values: any): Promise<any> {
	let resolve: (v: any) => void;
	let reject: (v: any) => void;
	const promise: any = new this((res, rej) => {
		resolve = res;
		reject = rej;
	});
	let count: number = 0;
	let index: number = 0;
	const resolvedValues: any[] = [];

	for (let value of values) {
		if (!(value && value.then))
			value = this.resolve(value);

		value.then(
			((index2) => (value2: any) => {
				resolvedValues[index2] = value2;
				count--;

				if (!count)
					resolve(resolvedValues);
			})(index),
			reject);
		count++;
		index++;
	}

	if (!count) resolve(resolvedValues);

	return promise;
};

// Global Buffer object
(window as any).global = window;
